/**
 * Settings > Sync status: everything that is syncing, per office. The
 * connector's current cycle from Dentrix or Open Dental (phase, entity,
 * records uploaded of total, last and next sync; a first full import shown
 * large with its ETA), the backfills still filling (DEXIS films, document
 * files, perio exams, lab cases) with rate and ETA, and what needs attention
 * (errors, paused sources, stalled feeds, PulseSync behind). Counts only, no
 * PHI. The same view opens from the top-bar sync chip. API:
 * `GET /v1/shell/sync-progress`.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'sync-status',
    title: 'Sync status',
    version: '0.1.0',
    owner: 'WP1-HEALTH',
    entitlementKey: null,
    permissions: [],
    routes: [
      {
        id: 'status',
        path: '/settings/sync-status',
        title: 'Sync status',
        officeScope: 'location-or-all',
        readsPhi: false,
      },
    ],
    nav: [
      {
        label: 'Sync status',
        group: 'settings',
        routeId: 'status',
        icon: 'refresh-cw',
        order: 936,
      },
    ],
    commands: [
      {
        id: 'sync-status.open',
        title: 'Sync status',
        keywords: [
          'sync',
          'progress',
          'backfill',
          'import',
          'dexis',
          'documents',
          'pulsesync',
          'loader',
          'eta',
        ],
        routeId: 'status',
      },
    ],
    sseEntityKeys: [],
    phiReadPoints: [],
  }),
  pages: {
    status: () => import('./SyncStatusPage.js'),
  },
});
